<div id="bandeau-portail" aria-hidden="true" [attr.data-appname-line1]="title" [attr.data-appname-line2]="applicationDescription"></div>
<app-bandeau-entete></app-bandeau-entete>
<router-outlet id="routerOutlet"></router-outlet>